import moment from 'moment';
import { AnimatePresence, motion } from 'framer-motion';
import { Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { CheckIcon } from '~/images/icons/CheckIcon';

interface IAutoSaveStatusProps {
  visible?: boolean;
  date?: Date | null;
}

export const AutoSaveStatus = ({ visible = false, date }: IAutoSaveStatusProps) => {
  const formattedDate = date ? moment(date).format('hh:mm a') : '';

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 100, opacity: 0 }}
          transition={{
            duration: 0.4,
            ease: [0.4, 0, 0.2, 1],
          }}
          style={{
            position: 'fixed',
            top: 110,
            right: 50,
            zIndex: 10,
          }}
        >
          <Row
            align="center"
            data-cy="auto-save-status"
            px={3}
            className="border border-neutral-200 bg-shades-0 shadow-elevation-drop-2dp"
            style={{ borderRadius: 12 }}
          >
            <CheckIcon size={20} color={colors.success[500]} />
            <Typography as="span" size="body_small">Draft saved • {formattedDate}</Typography>
          </Row>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
